import { combineReducers } from "redux-immutable";

import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import { classLeaderboardsCrudStateConfig } from "../../../consts";
import ClassLeaderboardsMetaStateSlice from "../../../models/meta/index";

const classLeaderboardsMetaReducer = makeCrudStateReducer(
  classLeaderboardsCrudStateConfig
);

export default combineReducers(
  {
    classLeaderboards: classLeaderboardsMetaReducer
  },
  () => new ClassLeaderboardsMetaStateSlice() as any
);
